import axios from 'axios'
import { attachJwtInterceptor } from '../../utils/jwtInterceptor'

/**
 * Public API connection
 */
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Content-Type'] = 'application/json'

export const API_UANG = axios.create({
  baseURL: process.env.REACT_APP_API_UANG,
})

export const API_AKADEMIK = axios.create({
  baseURL: process.env.REACT_APP_API_AKADEMIK,
})

export const API_AKADEMIK_LOCAL = axios.create({
  baseURL: process.env.REACT_APP_API_AKADEMIK_LOCAL,
})

export const API_MHS = axios.create({
  baseURL: process.env.REACT_APP_API_MHS,
})

export const API_MHS_KRS = axios.create({
  baseURL: process.env.REACT_APP_API_MHS_KRS,
})

export const API_ASTOR = axios.create({
  baseURL: process.env.REACT_APP_API_ASTOR,
})

export const CORE_API_AKADEMIK = axios.create({
  baseURL: process.env.REACT_APP_CORE_API_AKADEMIK,
})

// Pasang JWT Bearer Interceptor ke semua instance Axios
attachJwtInterceptor(API_UANG)
attachJwtInterceptor(API_AKADEMIK)
attachJwtInterceptor(API_AKADEMIK_LOCAL)
attachJwtInterceptor(API_MHS)
attachJwtInterceptor(API_MHS_KRS)
attachJwtInterceptor(API_ASTOR)
attachJwtInterceptor(CORE_API_AKADEMIK)